module.exports = __webpack_public_path__ + "static/media/crutch.9e805d7d.svg";